import * as React from 'react';

export const ThemeContext = React.createContext('light');



// WEBPACK FOOTER //
// ./src/components/theme/ThemeContext.ts